import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as Provider } from '@emotion/react';
import merge from 'lodash/merge';

import defaultTheme from './themes';

const ThemeProvider = ({ children, theme }) => {
  return <Provider theme={merge({}, defaultTheme, theme)}>{children}</Provider>;
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.shape().isRequired,
};

export default ThemeProvider;
